import VendorProductsContainer from "./VendorProductsContainer";

export default VendorProductsContainer;
